import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'withoutTimezone',
})
export class WithoutTimezonePipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  transform(value: string, format = 'MMM d, yyyy', isLowerCase = false) {
    if (value) {
      const datetime = value.substring(0, value.length - 6).replace(/-/g, '/');
      const date = new Date(Date.parse(datetime))?.toISOString();
      const result = this.datePipe.transform(date, format) || '';

      if (isLowerCase) {
        return result.toLowerCase();
      }

      return result;
    }

    return '';
  }
}
